module.exports = __webpack_public_path__ + "img/greyBlack.2454ee19.svg";